import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { ButtonType, Flex, SuccessAction } from '../../../../ui';
import { LoginForm } from '../../login';
import { StyledBackButton } from '../../forgottenPassword/components/styled';
import { useSidePopout } from '../../../../layout';

export enum NotifyActionType {
  QR_RESET = 'QR_RESET',
  TFA_PROVIDER_RESET = 'TFA_PROVIDER_RESET',
}

export const TfaNotifyActionSent: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { changePopoutContainer } = useSidePopout();

  return (
    <Flex style={{ paddingTop: '70px' }}>
      <StyledBackButton
        type={ButtonType.SecondaryAction}
        text={t('landingPage.forgottenPasswordForm.backToLogin')}
        onClick={() =>
          changePopoutContainer({
            newContainer: <LoginForm />,
            urlKey: 'login',
          })
        }
      />
      <SuccessAction
        success
        title={
          (history.location.state as any).type ===
          NotifyActionType.TFA_PROVIDER_RESET
            ? t('landingPage.notifyActionsTfaProvider.requestTitle')
            : t('landingPage.notifyActionsTfaProvider.qrResetTitleText')
        }
        buttonText={
          (history.location.state as any).type ===
          NotifyActionType.TFA_PROVIDER_RESET
            ? t('landingPage.notifyActionsTfaProvider.requestButtonText')
            : t('landingPage.notifyActionsTfaProvider.qrResetButtonText')
        }
        onClick={() => {
          history.push('/');
        }}
      />
    </Flex>
  );
};
